import home from "@/content/home.json";

export const homeContent = home;
